<template>
  <BreadCrumb PageTitle="Paramètres du compte" />
  <DeliveryProviderSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import DeliveryProviderSettings from "../../components/Generals/AccountSettings/DeliveryProviderSettings.vue";

export default defineComponent({
  name: "DeliveryProvidersPage",
  components: {
    BreadCrumb,
    DeliveryProviderSettings,
  },
});
</script>
